/**
 * siteConfig — single source of truth for SEO/brand metadata.
 * Used by <Seo>, structuredData builders, and the sitemap generator.
 */
export const siteConfig = {
  siteName: "LinkLane",
  baseUrl: "https://linklane.io",
  docsUrl: "https://docs.linklane.io",
  shortHost: "lny.me",
  tagline: "Smart links. AI that gets it.",
  defaultDescription:
    "LinkLane is the AI-native link platform: short links, branded QR codes, smart routing, bio pages, and analytics that AI explains for you. Free to start.",
  defaultOgImage: "https://linklane.io/og/default.png",
  twitterHandle: "@linklane",
  titleTemplate: "%s · LinkLane",
  locale: "en_US",
  organization: {
    name: "LinkLane",
    url: "https://linklane.io",
    logo: "https://linklane.io/linklane-logo.png",
    sameAs: ["https://x.com/linklaneio", "https://www.linkedin.com/company/linklane"],
  },
};

export default siteConfig;
